import { checkProductsIsConfection } from '../categoryUtils';

/**
 * Methods to filter out confection products
 * return object of two arrays - 1. array of products without confection items. 2. filterout confection items
 * @returns {{confectionItems: [], productsWithoutConfection: []}}
 * @param products - to be sorted
 */
export const filterOutConfectionProduct = (products = []) => {
  if (products.length === 0) return { productsWithoutConfection: [], confectionItems: [] };
  const productsWithoutConfection = [];
  const confectionItems = [];

  products.forEach((product) => {
    if (checkProductsIsConfection(product)) {
      confectionItems.push(product);
    } else {
      productsWithoutConfection.push(product);
    }
  });

  return { productsWithoutConfection, confectionItems };
};

/**
 * Method to filter products only for particular delivery number
 * @description best way to use it is pass products array without confection item
 * @param products
 * @param deliveryNumber
 * @returns {[] | *[]}
 */
export const filterProductsForDeliveryNumber = (products = [], deliveryNumber = 0) => {
  if (products.length === 0) return [];
  const result = [];

  products.forEach((product) => {
    if (product.iddelivery === deliveryNumber) {
      result.push(product);
    }
  });
  return result;
};
